import Fetch from '@/utils/Fetch';

const getFeedbackList = async (itemID: any, module: any) => {
    let request = await Fetch.post({
        url: '/Feedback/GetFeedback',
        params: {
          itemID,
          module
        }
    });

    return {data: request.Results, total: request.TotalResults};
};

const getFeedbackListCustomerZone = async (tenantID: any, customerID: any, api: any, itemID: any, module: any) => {
    let request = await Fetch.post({
        url: '/CustomerZone/GetFeedback',
        params: {
          itemID,
          module
        },
        tenantID: tenantID,
        customerID: customerID,
        apiUrlOverride: api
    });

    return {data: request.Results, total: request.TotalResults};
};

const hasFeedbackForTenant = async () => {
    let request = await Fetch.get({
        url: '/Feedback/FeedbackForTenant'
    });
    return request ? true : false;
};

const getFeedbackByItemIDCustomerZone = async (itemID: any, tenantID: any, customerID: any, api: any) => {
    return await Fetch.get({
        url: '/CustomerZone/FeedbackGetByItemID',
        params: {
            itemID,
        },
        tenantID: tenantID,
        customerID: customerID,
        apiUrlOverride: api
    });
};

const saveFeedbackCustomerZone = async (feedback: any, tenantID: any, customerID: any, api: any) => {
    let result = await Fetch.put({
        url: '/CustomerZone/FeedbackPut',
        params: feedback,
        tenantID: tenantID,
        customerID: customerID,
        apiUrlOverride: api
    });

    return result;
};

export default {
    getFeedbackList,
    getFeedbackListCustomerZone,
    hasFeedbackForTenant,
    getFeedbackByItemIDCustomerZone,
    saveFeedbackCustomerZone,
};
